import {Decoverto} from 'decoverto';

export const decoverto = new Decoverto();
